export type TestBase = {
  id: number
  name: string
  active: boolean
}
export type sampleRow = {
  label: string
  value: number
}

export type LabTest = TestBase & {
  panelId: number
  panelName: string
  sampleId: number
  sampleName: string
  description: string
  controlled?: boolean
  samples?: any
}

export type Panel = TestBase & {
  sampleId: number
  sampleName: string
  lab_tests: LabTest[]
}

export type Sample = TestBase & {
  description: string
}

export type OrderEventTestType =
  | 'ORDERED'
  | 'ORDER_MODIFIED'
  | 'COLLECTED'
  | 'COLLECTION_APPROVED'
  | 'COLLECTION_REJECTED'
  | 'ENTERED'
  | 'ENTERED_REFERRED'
  | 'SUBMITTED'
  | 'APPROVED'
  | 'REJECTED'
  | 'LOC_ALLOCATED'

export type OrderEventTest = {
  test_id: number
  status: OrderEventTestType
  updatedBy: string
  updatedOn: string
}

export type OrderEventType =
  | 'ORDERED'
  | 'ORDER_MODIFIED'
  | 'COLLECTION_IN_PROGRESS'
  | 'COLLECTION_COMPLETED'
  | 'COLLECTION_APPROVED'
  | 'COLLECTION_REJECTED'
  | 'RESULTS_ENTERED'
  | 'REFERRED_RESULTS_ENTERED'
  | 'RESULTS_SUBMITTED'
  | 'RESULTS_APPROVED'
  | 'RESULTS_REJECTED'
  | 'CANCELLED'
  | 'LOC_ALLOCATED'

export type OrderEvent = {
  id: number
  type: OrderEventType
  tests?: OrderEventTest[]
  comments?: string
  created_at: string
  updated_at: string
  updated_by: string
  order_id: string
  authorised_by_id?: string
  authorised_by_name?: string
}

export type OrderEventTests = {
  updatedOn: string
  updatedBy: string
  test_id: number
  status: string
}

export type LabOrder = {
  id?: string
  visit_id?: number
  panels?: Panel[]
  lab_tests?: LabTest[]
  lab_results?: any[]
  lr_number?: string
  patient_id?: string
  ordered_on?: string
  ordered_by_id?: string
  ordered_by_name?: string
  payment_status?: string
  payment_completed_on?: string
  collection_completed_on?: string
  validation_completed_on?: string
  validated_by_id?: string
  validated_by_name?: string
  status?: string
  source?: string
  price?: number
  package_id?: number | null
  summary?: string
  order_events?: OrderEvent[]
  requested_by?: string
  origin?: string
  radiology_events?: any
  radiology_lab_tests?: any
  authorised_by_id?: string
  authorised_by_name?: string
  result_entered_by?: string
  odoo_invoice_id?: any
  ref_id?: any
  operating_unit?: any
  collection_completed_by_id?: any
  collection_completed_by_name?: any
  operating_units?: string[]
}

export type RadiologyTest = TestBase & {
  sampleId: number
  description: string
  panel: Test | null
  origin: { label: string; value: string } | null
}

export type RadiologyOrder = {
  id?: number
  visit_id?: number
  lab_tests?: RadiologyTest[]
}

export type LabMode = '' | 'package' | 'test'

export type LabTests = {
  name: string
  description: string
  id: number
}

export type Test = {
  name: string
  description: string
  id: number
  lab_tests: LabTests[]
  sampleId: number
  sampleName: string
  odoo_test_id: any
  processing_unit: any
  price?: any
  discount?: any
}

export type Row = {
  defaultPrice?: any
  mode: { label: string; value: string } | null
  requestedBy: any
  sampleName: { label: string; value: string } | null
  testName: { label: string; value: string; odoo_test_id: any } | null
  panel: Test | null
  origin: { label: string; value: string } | null
  qty?: any
  price?: number
  panels?: any
  OdooPackageId?: number
  packagePrice?: number
  productName?: string
  packageId?: number
  discount?: number
}
export type NewRow = {
  sampleName: { label: string; value: string } | null
  testName: { label: string; value: string } | null
  panel: Test | null
}
export const GetSlotData = 'GetSlotData'
export const PriceList = 'price_list'
export const orderSucess = 'Lab Order Saved Successfully'
export const orderSubmit = 'Lab Order Created Successfully'
export const errorinvoice = 'Error creating invoice'
export const orderValidationmsg = 'Please add at least one test to submit'
export const NewOrder = 'New Order'
export const orderMsg = {
  sampleName: 'Please select a Sample Name before adding.',
  TestName: 'Please select a Test Name before adding.',
  RequestedBy: 'Please select Requested By before adding.',
  mode: 'Please select a Mode before adding.',
  failedmsg: 'Failed to create invoice. Please try again.',
  ordercancelled: 'Order cancelled successfully',
  errorcancel: 'Error canceling order:',
}
export const lmsIntent = {
  createOrderEvent: 'createOrderEvent',
  getLabOrdersByPatientIdForOpd: 'getLabOrdersByPatientIdForOpd',
  getLabOrdersApi: 'getLabOrdersApi',
  getVisitApi: 'getVisitApi',
}
export const optionValue = {
  origin: { value: 'OPD', label: 'OPD' },
  ipd: { value: 'IPD', label: 'IPD' },
  b2b: { value: 'B2B', label: 'B2B' },
  partner: { value: 'Partner', label: 'Partner' },
  others: { value: 'Others', label: 'Others' },
  test: { value: 'test', label: 'Lab Test' },
  package: { value: 'package', label: 'Lab Package' },
  self: { value: 'Self', label: 'Self' },
  external: { value: 'EXTERNAL', label: 'External' },
  LAB: { value: 'LAB', label: 'LAB' },
}
export const LmstableHeading = {
  Mode: 'Mode',
  Origin: 'Origin',
  RequestedBy: 'Requested By',
  TestName: 'Test Name',
  Price: 'Price',
  Action: 'Action',
  sampleName: 'Sample Name',
  CollectedBy: 'Collected By',
}
export const test = 'test'
export const LoadPrice = 'Loading price...'
export const add = 'Add'
export const NotPaid = 'not_paid'
export const paid = 'paid'
export const saleOrder = 'Load Sale Orders'
export const invoice = 'Load Invoice'
export const AcknowledgeBy = 'Acknowledge By'
export const externalName = 'Enter external name'
export const success = 'success'
export const error = 'error'
export const opd = 'opd'
export const SaleOrder = 'sale_order'
export const invoiceData = 'invoice'
export const failedMsg = 'UpdateLabInvoice failed'
export const cancel = 'cancel'
export const priceFailedMsg =
  'Failed to get product from odoo. Cannot add product.'
export const priceListNotFound = 'Price not found or zero'
export const ORDER_INVOICE_TEXT = {
  SL_NO: 'Sl no',
  ORDER_ID: 'Order Id',
  ORDER_TYPE: 'Order Type',
  ORDER_DATE: 'Order Date',
  UHID: 'UHID',
  NAME: 'Name',
  MOBILE_NO: 'Mobile No',
  SERVICE: 'Service',
  OPERATING_UNIT: 'Operating Unit',
  TOTAL: 'Total',
  AMOUNT_DUE: 'Amount Due',
  PAY_STATUS: 'Pay Status',
  STATUS: 'Status',
  INVOICE_NO: 'Invoice No',
  INVOICE_STATUS: 'invoiceStatus',
  CREATED_ON: 'Created On',
  UPDATED_ON: 'Updated On',
  INVOICE: 'Invoice',
  SALE_ORDER: 'Sale Order',
  LOC: 'Loc',
  ORDERS: 'Orders',
  SEARCH_ORDERS: 'Search Orders',
  CREATE: 'Create',
  INVOICETEXT: 'invoice',
  INVOICE_NUMBER_TEXT: 'invoiceNo',
}
export const partial = 'partial'
export const partialUpperCase = 'Partial'
export const noInvoiceText = 'No Invoice'
export const lowerCasePaid = 'paid'
export const noTestsFound = 'No Tests'
export const noInvoice = 'noInvoice'
export const INVOICE_STATUS = {
  CANCELLED: 'cancelled',
  UNPAID: 'unpaid',
  NOINVOICE: 'noInvoice',
  PARTIAL: 'partial',
  PAID: 'paid',
  UNKNOWN: 'Unknown',
}
export const opdTest = 'test'
export const labConstant = 'lab'
export const radiologyLab = 'RAD,LAB'
export const labModule = {
  labTest: 'Lab Test',
  labPackage: 'Lab Package',
}

export const CREATE_LAB_RESULT = 'createLabResult'
export const UPDATE_LAB_ORDERS_SHORT = 'updateLabOrdersShort'
export const CREATE_ORDER_EVENT = 'createOrderEvent'
export const COLLECTION_APPROVED = 'COLLECTION_APPROVED'
export const ERROR_LAB_RESULT = 'Failed to create Lab Result'
export const ERROR_UPDATE_ORDER = 'Failed to update Lab Order'
export const ERROR_CREATE_EVENT = 'Failed to create Order Event'
export const GENERIC_ERROR = 'Something went wrong while processing the request'
export const SAMPLE_APPROVED_MSG =
  'Lab Sample Collection Approved. Redirecting to Dashboard...'
export const SelectMsg = 'Please select samples to approve'
export const Tryagain = 'Please Try Again'
